import Vue from 'vue'
import fastclick from 'fastclick'
import 'swiper/swiper-bundle.min.css'
import 'lib-flexible'

//引入axios插件
// import { $get, $post } from './utils/axios'


//引入Vconsole
// import Vconsole from 'vconsole';

// 引入全局组件 squareDivImg
import MainTitle from '@/components/mainTitle/mainTitle'
import SwiperImgTxt from '@/components/swiperImgTxt/swiperImgTxt'
import SingleWork from '@/components/singleWork/singleWork'
import Waves from '@/components/waves/waves'
import MusicBox from '@/components/musicBox/musicBox' // 音乐
import Loading from '@/components/loading/loading' // 加载页面
import MoveWaves from '@/components/moveWaves/moveWaves' // 移动的海浪
import IntroPop from '@/components/introPop/introPop' // 人物图文介绍
import AnimalBtn from '@/components/animalBtn/animalBtn' // 动物按钮
import CategoryAnimal from '@/components/categoryAnimal/categoryAnimal' // 单个动物类
import MoveImg from '@/components/moveImg/moveImg'
import SquareDivImg from '@/components/squareDivImg/squareDivImg'


// 注册全局组件 
Vue.component('mainTitle', MainTitle)
Vue.component('swiperImgTxt', SwiperImgTxt)
Vue.component('singleWork', SingleWork)
Vue.component('waves', Waves)
Vue.component('musicBox', MusicBox)
Vue.component('loading', Loading)
Vue.component('moveWaves', MoveWaves)
Vue.component('introPop', IntroPop)
Vue.component('animalBtn', AnimalBtn)
Vue.component('categoryAnimal', CategoryAnimal)
Vue.component('moveImg', MoveImg)
Vue.component('squareDivImg', SquareDivImg)


export const initPlugins = function () {

  fastclick.attach(document.body);
  // Vue.prototype.$cookie = cookie;
  // process.env.NODE_ENV === new Vconsole()
}
